import { useActivity } from "../context/ActivityContext";

// Utility functions for common activities
export const useActivityUtils = () => {
  const { addActivity } = useActivity();

  const logCreateFolder = (folderName: string) => {
    addActivity({
      type: "create",
      action: "folder",
      name: folderName,
      description: `Created new folder "${folderName}"`,
    });
  };

  const logCreateFile = (fileName: string) => {
    addActivity({
      type: "create",
      action: "file",
      name: fileName,
      description: `Created new file "${fileName}"`,
    });
  };

  const logCreateComponent = (componentName: string) => {
    addActivity({
      type: "create",
      action: "component",
      name: componentName,
      description: `Created new component "${componentName}"`,
    });
  };

  const logDeleteFolder = (folderName: string) => {
    addActivity({
      type: "delete",
      action: "folder",
      name: folderName,
      description: `Deleted folder "${folderName}"`,
    });
  };

  const logDeleteFile = (fileName: string) => {
    addActivity({
      type: "delete",
      action: "file",
      name: fileName,
      description: `Deleted file "${fileName}"`,
    });
  };

  const logDeleteComponent = (componentName: string) => {
    addActivity({
      type: "delete",
      action: "component",
      name: componentName,
      description: `Deleted component "${componentName}"`,
    });
  };

  const logUpdateFile = (fileName: string) => {
    addActivity({
      type: "update",
      action: "file",
      name: fileName,
      description: `Updated file "${fileName}"`,
    });
  };

  const logUpdateComponent = (componentName: string) => {
    addActivity({
      type: "update",
      action: "component",
      name: componentName,
      description: `Updated component "${componentName}"`,
    });
  };

  const logCopyComponent = (componentName: string) => {
    addActivity({
      type: "copy",
      action: "component",
      name: componentName,
      description: `Copied component "${componentName}" to clipboard`,
    });
  };

  const logCopyCode = (codeType: string) => {
    addActivity({
      type: "copy",
      action: "component",
      name: codeType,
      description: `Copied ${codeType} code to clipboard`,
    });
  };

  return {
    logCreateFolder,
    logCreateFile,
    logCreateComponent,
    logDeleteFolder,
    logDeleteFile,
    logDeleteComponent,
    logUpdateFile,
    logUpdateComponent,
    logCopyComponent,
    logCopyCode,
  };
};
